// CV.js
import React from "react";
import { motion } from "framer-motion";
import "./CV.css";


function CV() {
  return (
    <motion.div
      className="cv-container"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="cv-box">
        <h1 className="cv-title">Currículum Vitae</h1>
        <section>
          <h2>Educación</h2>
          <ul>
            <li>2024: Asistencia al curso EL PRADO DEL SIGLO XXI, Universidad Complutense de Madrid.</li>
            <li>2023-2024: Máster en Mercado del Arte y Gestión de Empresas Relacionadas, Universidad Nebrija.</li>
            <li>2018-2023: Grado en Arte, Universidad del País Vasco (UPV/EHU). Especialidad en pintura y dibujo. Calificación TFG: 10.</li>
          </ul>
        </section>
        <section>
          <h2>Premios</h2>
          <ul>
            <li>2024: Tercer premio de la XL Muestra de Arte Joven de La Rioja, Gobierno de La Rioja e IRJ.</li>
          </ul>
        </section>
        <section>
          <h2>Exposiciones / Trabajos</h2>
          <ul>
            
            <li>2024: Exposición colectiva de la XL Muestra de Arte Joven de La Rioja, ESDIR.</li>
            <li>2024: Comisariado de exposicion Underwater de Rubén Abstract, en restaurantes Lateral.</li>
            <li>2024: Comisariado de exposiciones Horizontes, Luz y Oscuridad de Isabela Puga en restaurantes Lateral.</li>
            <li>2024: Asistente de estudio de Marina Vargas.</li>
            <li>2023: Exposición Trabajo de Fin de Grado, Facultad de Bellas Artes, País Vasco.</li>
            <li>2022-2023: Trabajo de muralismo, Facultad de Bellas Artes UPV/EHU.</li>
            <li>2018: Exposición colectiva Miscelánea, La Gota de Leche, Logroño, La Rioja.</li>
          </ul>
        </section>
      </div>


    </motion.div>
  );
}

export default CV;